<template>
  <basic-block :value="value" :mode="mode" :state.sync="state">
    <template v-slot:main>
      <ShapeControlHandle
        v-if="isVisibleShapeControlHandle"
        class="shape-double-arrow-control-handler-x"
        :x="slope"
        :x-range="[width * 0.51, width]"
        :y="0"
        :angle="value.rotation"
        @update:x="updateSlope" />
      <ShapeControlHandle
        v-if="isVisibleShapeControlHandle"
        class="shape-double-arrow-control-handler-y"
        :x="width - slope"
        :y="thick"
        :y-range="[0, height * 0.49]"
        :angle="value.rotation"
        @update:y="updateThick" />
      <svg
        class="shape-double-arrow"
        style="vertical-align: top"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width="100%"
        height="100%"
        preserveAspectRatio="none"
        :viewBox="`0 0 ${width} ${height}`">
        <defs>
          <path
            :id="`path-${id}`"
            :d="`
                M ${width} ${height / 2}
                L ${slope} 0
                L ${slope} ${thick}
                L ${width - slope} ${thick}
                L ${width - slope} 0
                L 0 ${height / 2}
                L ${width - slope} ${height}
                L ${width - slope} ${height - thick}
                L ${slope} ${height - thick}
                L ${slope} ${height}
                L ${width} ${height / 2}
              `"
            :style="value.data.style"
            stroke-linecap="round" />
          <clipPath :id="`clip-${id}`">
            <use :xlink:href="`#path-${id}`" />
          </clipPath>
        </defs>
        <g>
          <use :xlink:href="`#path-${id}`" :clip-path="`url(#clip-${id})`" />
        </g>
      </svg>
    </template>
  </basic-block>
</template>

<script>
import BasicBlock from "../_components/containers/BasicBlock.vue"
import ShapeControlHandle from "../_components/utils/ShapeControlHandle.vue"
import { BlockSelectionState } from "../_models/blockSelectionState";

export default {
  name: "BlockShapeDoubleArrow",
  components: {
    BasicBlock,
    ShapeControlHandle
  },
  props: ["value", "mode"],
  data() {
    return {
      state: BlockSelectionState.notSelected
    }
  },
  computed: {
    isVisibleShapeControlHandle() {
      return this.state === BlockSelectionState.primarySelected && this.mode === "edit";
    },
    id() {
      return this.value.id
    },
    width() {
      return this.value.size.width
    },
    height() {
      return this.value.size.height
    },
    slope() {
      return this.value.size.width * this.value.data.controls.slope
    },
    thick() {
      return this.value.size.height * this.value.data.controls.thick
    }
  },
  methods: {
    updateSlope(value) {
      const slopePx = Math.round(value)
      this.value.data.controls.slope = slopePx / this.width
    },
    updateThick(value) {
      const thickPx = Math.round(value)
      this.value.data.controls.thick = thickPx / this.height
    }
  },
  watch: {
    width(newWidth, oldWidth) {
      if (!newWidth) return

      const slopePx = this.value.data.controls.slope * oldWidth
      const distanceFromRight = oldWidth - slopePx
      const newSlopePercentage = (newWidth - distanceFromRight) / newWidth

      this.value.data.controls.slope = newSlopePercentage
    },
    height(newHeight, oldHeight) {
      if (!newHeight) return

      const thickPx = this.value.data.controls.thick * oldHeight
      const distanceFromCenter = (oldHeight / 2) - thickPx
      const newThickPercentage = 0.5 - (distanceFromCenter / newHeight)

      this.value.data.controls.thick = newThickPercentage
    }
  }
}
</script>
